import { css } from '@conexasaude/hero-web'
import { SerializedStyles } from '@emotion/utils'

type Breakpoint = 'phone' | 'tablet' | 'small-desktop' | 'desktop'

export const BREAKPOINT_SIZES = {
  phone: {
    minWidth: 'none',
    maxWidth: '639px',
    query: '(max-width: 639px)',
  },
  tablet: {
    minWidth: '640px',
    maxWidth: '1023px',
    query: '(min-width: 640px) and (max-width: 1023px)',
  },
  'small-desktop': {
    minWidth: '1024px',
    maxWidth: '1087px',
    query: '(min-width: 1024px) and (max-width: 1087px)',
  },
  desktop: {
    minWidth: '1088px',
    maxWidth: 'none',
    query: '(min-width: 1088px)',
  },
}

export const breakpointMixin = (
  breakpoint: Breakpoint,
  styles: SerializedStyles,
): SerializedStyles => {
  return css`
    @media ${BREAKPOINT_SIZES[breakpoint].query} {
      ${styles}
    }
  `
}
